import { AutoAnimationPlugin } from '@formkit/auto-animate'

export const addRemoveAnimation: AutoAnimationPlugin = ((
  el: Element,
  action: 'add' | 'remove' | 'remain',
) => {
  const easing = 'ease-in';
  let duration = 100;
  let keyframes: { [key: string]: string | number }[] = []

  if (action === 'add') {
    keyframes = [
      {
        transform: 'scale(.98)',
        opacity: 0,
      },
      {
        transform: 'scale(0.98)',
        opacity: 0,
        offset: 0.5,
      },
      {
        transform: 'scale(1)',
        opacity: 1,
      },
    ]
  }

  if (action === 'remove') {
    duration = 0;
  }

  return new KeyframeEffect(el, keyframes, { duration, easing })
});

